import React from 'react';
import { useSEO } from '../hooks/useSEO';

export default function LegalLayout({ title, lastUpdated, seoTitle, seoDescription, canonical, children }) {
  useSEO({
    title: seoTitle || `${title} | PlanningSearch`,
    description: seoDescription || `${title} for PlanningSearch — UK planning application intelligence platform.`,
    canonical: canonical || `https://planningsearch.com/${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  });

  return (
    <div className="min-h-[calc(100vh-56px)] bg-white" data-testid={`legal-page-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="mb-10 border-b border-zinc-200 pb-8">
          <h1 className="font-['Manrope'] text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-900 mb-2">
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-sm text-zinc-500 font-medium tracking-wide uppercase">
              Last updated: {lastUpdated}
            </p>
          )}
        </div>
        <div className="prose prose-zinc prose-sm max-w-none prose-headings:font-['Manrope'] prose-headings:font-bold prose-headings:text-zinc-900 prose-a:text-emerald-600 hover:prose-a:text-emerald-700 prose-p:text-zinc-600 prose-p:leading-relaxed prose-li:text-zinc-600">
          {children}
        </div>
      </div>
    </div>
  );
}
